<template>

 <div>
     <el-button type="warning" v-if="(change || newPsw || isSuper() || form.login === profile().login)" :disabled="(!newPsw && !change) || disabled" @click="changePassword">{{title}} Password</el-button>
     <el-button type="danger" v-if="isSuper() && !newPsw" :disabled="!isSuper() || true" @click="resetPassword">Reset Password</el-button>

   <el-dialog class="text-left" :title="title + ' Password'" :visible.sync="changePsw">

     <password-form v-if="!loading" v-model="form" :change="change" :new-psw="newPsw" :inline="false" :toggle="toggle" />

     <span slot="footer" class="dialog-footer">
       <el-button @click="changePsw = false">Cancel</el-button>
       <el-button type="success" @click="savePsw" :disabled="!passwordsMatch">Save</el-button>
     </span>
   </el-dialog>
 </div>


 </div>

</template>

<script>

import MD5 from 'crypto-js/md5'
import PostMixins from '@/mixins/PostMixins'

import PasswordForm from '@/components/login/PasswordForm'

export default {

  mixins: [PostMixins],

  components: {
    PasswordForm
  },

  props: {
    value: {
      required: true
    },

    toggle: {
      type: Boolean,
      default: true
    },

    change: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: true
    },

    newPsw: {
      type: Boolean,
      default: false
    },

  },

  watch: {

    value: function (d) {
      this.form = d
//      console.log('PasswordDialog', this.form, this.change)
    }

  },


  computed: {
    passwordsMatch: function () {

      if (this.form.password && this.form.c_password && this.form.password.length >= 7) {
        return (this.form.password === this.form.c_password)
      }

    return false
    }
  },




  methods: {
    savePsw () {

      if (this.changePsw) {
         this.changePsw = false
         this.form.password = MD5(this.form.password.trim()).toString()
         console.log('password', this.form.password)

         let pass = {
           password: this.form.password,
           email: this.form.email
         }

         this.saveForm(this, '/password/change', this.form.id, pass,  'Change Password', this.changePasswordSuccess)
      }

    },

    changePassword () {
      this.changePsw = true
    },

    formChange (data) {
      this.loading = false
      this.form = data
    },

    resetPasswordSuccess (data) {

      this.$alert('Reset e-mail to ' + this.form.email, 'Reset Password',
       {
        confirmButtonText: '  OK'
      }
    )

    },

    resetPassword() {
      this.saveForm(this, '/password/reset', this.form.id, null,  'Reset Password', this.resetPasswordSuccess)
    }

  },

  data () {
    return {
      changePsw: false,
      resetPsw: false,
      loading: true,
      form: this.value,
      title: (this.newPsw ? 'New' : 'Change')
    }
  },

  created () {
    if (this.change) {
      this.fetchData('/contacts/' + this.form.id, this.formChange, 'Contact')
    }
  }
}

</script>



// WEBPACK FOOTER //
// PasswordDialog.vue?4228a9bd